import styled from 'styled-components';
import { SplitDown, SplitUp } from '../Icons';
import { DIRECTION } from '../../constants';
import COLORS from '../../colors';

interface SplitWeekProps {
  isSplit: boolean;
  direction: DIRECTION;
  numberOfDays: number;
}

const StyledSplitWeekText = styled.div`
  position: relative;
  letter-spacing: 0.1px;
  line-height: 20px;
  font-weight: 500;
`;

const StyledSplitWeekContainer = styled.div`
  position: relative;
  border-radius: 4px;
  background-color: ${COLORS.NEUTRAL_800};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  box-sizing: border-box;
  gap: 8px;
  text-align: center;
  font-size: 14px;
  color: ${COLORS.PRIMARY_500};
`;

const SplitWeek = ({ isSplit, direction }: SplitWeekProps) => {
  return isSplit ? (
    <StyledSplitWeekContainer>
      {direction == DIRECTION.DOWN ? <SplitDown /> : <SplitUp />}
    </StyledSplitWeekContainer>
  ) : (
    <></>
  );
};

export default SplitWeek;
